var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64286 15.3571H15.3571M4.64286 15.3571C3.45939 15.3571 2.5 14.3978 2.5 13.2143V8.39286C2.5 7.50525 3.21954 6.78571 4.10714 6.78571C4.29499 6.78571 4.4753 6.81794 4.64286 6.87716M4.64286 15.3571V17.5M15.3571 15.3571C16.5406 15.3571 17.5 14.3978 17.5 13.2143V8.39286C17.5 7.50525 16.7804 6.78571 15.8929 6.78571C15.705 6.78571 15.5247 6.81794 15.3571 6.87716M15.3571 15.3571V17.5M4.64286 6.87716C5.26707 7.09779 5.71429 7.6931 5.71429 8.39286V11.0714H14.2857V8.39286C14.2857 7.6931 14.7329 7.09779 15.3571 6.87716M4.64286 6.87716V6.78571C4.64286 4.41878 6.56164 2.5 8.92857 2.5H11.0714C13.4383 2.5 15.3571 4.41878 15.3571 6.78571V6.87716",
    stroke: "#234943",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/workspace.99520c9c3a7509c289e74c8c3555219c.svg";
export { ForwardRef as ReactComponent };